class PremiumSrc extends lm.Composant {
  constructor(id) {
    super(id);
    this.premiumContainer = document.querySelector(".js-premium-container");
    this.premiumLines = document.querySelectorAll('.js-premium-line-extra');
    this.buttonShow = document.querySelector('.js-button-premium-show');
    this.buttonHide = document.querySelector('.js-button-premium-hide');
    this.classLineHidden = 'o-product-detail-premium__line--hidden';
    if (this.premiumContainer && this.buttonShow && this.buttonHide) {
      this.listenButtonsEvents();
    }
    this.videos = document.querySelectorAll('.video-js');
    if (this.videos) {
      this.initVideos();
    }
  }

  /**
   * listenButtonsEvents : listen event on buttons show / hide more content
   */
  listenButtonsEvents() {
    const _that = this;
    this.buttonShow.addEventListener('click', function () {
      _that.showProductDetails();
    });
    this.buttonHide.addEventListener('click', function () {
      _that.hideProductDetails();
    });
  }

  /**
   * showProductDetails : toggle (show) for show more content
   * @param  {htmlNode} buttonShow
   * @param  {htmlNode} buttonHide
   * @param  {htmlNode} premiumContainer
   */
  showProductDetails() {
    this.buttonHide.classList.remove('kl-hidden');
    this.buttonShow.classList.add('kl-hidden');
    this.premiumContainer.classList.remove('is-collapse');
    this.premiumLines.forEach(line => {
      line.classList.remove(this.classLineHidden);
    });
  }

  /**
   * hideProductDetails : toggle (hide) for hide content
   * @param  {htmlNode} buttonShow
   * @param  {htmlNode} buttonHide
   * @param  {htmlNode} premiumContainer
   */
  hideProductDetails() {
    this.buttonShow.classList.remove('kl-hidden');
    this.buttonHide.classList.add('kl-hidden');
    this.premiumContainer.classList.add('is-collapse');
    this.premiumLines.forEach(line => {
      line.classList.add(this.classLineHidden);
    });
    window.scroll(0, this.premiumContainer.offsetTop);
  }
  initVideos() {
    import(/* webpackChunkName: "video" */'./../legacy/_video.class').then(module => {
      new module.default();
    }).catch(console.error);
  }
}
lm.DOMReady(function () {
  new PremiumSrc("premium");
});
export default PremiumSrc;